import React, { useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useI18n } from "@/context/i18n";
import { toast } from "sonner";
import { Bell, BellRing, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const goLogin = () => {
  sessionStorage.setItem("postLoginRedirect", window.location.pathname + window.location.search);
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const WatchButton = ({ payload, className = "", compact = false }) => {
  const { user } = useApp();
  const { t } = useI18n();
  const [loading, setLoading] = useState(false);
  const [watched, setWatched] = useState(false);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) return goLogin();
    setLoading(true);
    try {
      await api.post("/watches", payload);
      setWatched(true);
      toast.success(t("watch_added"));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not add to watchlist");
    } finally {
      setLoading(false);
    }
  };

  const Icon = loading ? Loader2 : watched ? BellRing : Bell;
  return (
    <button
      data-testid={`watch-btn-${payload.hotelCode}`}
      onClick={onClick}
      disabled={loading || watched}
      title={t("watch_price")}
      className={`inline-flex items-center gap-2 font-bold transition-colors disabled:opacity-70 ${className}`}
    >
      <Icon className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
      {!compact && (watched ? t("watching") : t("watch_price"))}
    </button>
  );
};
